import React from 'react';
import { Typography, Button } from 'antd';

const { Title } = Typography;

interface CreatedTodayHeaderProps {
  onRefresh: () => void;
  loading: boolean;
}

const CreatedTodayHeader: React.FC<CreatedTodayHeaderProps> = ({
  onRefresh,
  loading,
}) => (
  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
    <Title level={3} className="!mb-0">
      Kỳ đáo hạn tạo hôm nay
    </Title>
    <Button onClick={onRefresh} loading={loading} type="default">
      Làm mới
    </Button>
  </div>
);

export default CreatedTodayHeader;
